import { APP } from '../../redux/constants/app.constants';

export const SIM_CARD_PAGE = `${APP}/simCardPage`;
export const DEACTIVATE_SIM_CARD = `${SIM_CARD_PAGE}/DEACTIVATE_SIM_CARD`;
export const ACTIVATE_SIM_CARD = `${SIM_CARD_PAGE}/ACTIVATE_SIM_CARD`;
export const RETIRE_SIM_CARD = `${SIM_CARD_PAGE}/RETIRE_SIM_CARD`;
export const CANCEL_SIM_CARD_SCHEDULE = `${SIM_CARD_PAGE}/CANCEL_SIM_CARD_SCHEDULE`;
export const SAVE_SIM_CARD = `${SIM_CARD_PAGE}/SAVE_SIM_CARD`;